import { Component, OnInit, Input } from "@angular/core";
import { ImageCroppedEvent } from "ngx-image-cropper";

@Component({
  selector: "crop-image",
  templateUrl: "./crop-image.component.html",
  styleUrls: ["./crop-image.component.scss"]
})
export class CropImageComponent implements OnInit {
  imageChangedEvent: any = "";
  @Input() croppedImage = {};
  @Input() maintainAspectRatio = true;

  constructor() {}

  ngOnInit() {}

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage["value"] = event.file;
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
}



// WEBPACK FOOTER //
// ./src/app/components/crop-image/crop-image.component.ts